import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { containerReducer } from "./Reducers/Container";
import { signupReducer } from "./Reducers/Signup";
import { checkEmailReducer } from "./Reducers/CheckEmail";
import { signoutReducer } from "./Reducers/Signout";
import { confirmReducer } from "./Reducers/Confirm";
import { appReducer } from "./Reducers/App";
import { loadingReducer } from "./Reducers/Loading";
import { forgotPasswordReducer } from "./Reducers/ForgotPassword";
import { contactsReducer } from "./Reducers/Contacts";
import { tokenReducer } from "./Reducers/Token";
import { personCreateReducer } from "./Reducers/PersonCreate";
import { personUpdateReducer } from "./Reducers/PersonUpdate";
import { propertyCreateReducer } from "./Reducers/PropertyCreate";
import { propertyUpdateReducer } from "./Reducers/PropertyUpdate";
import { unitCreateReducer } from "./Reducers/UnitCreate";
import { unitUpdateReducer } from "./Reducers/UnitUpdate";
import { unitDefaultChargeTemplatesReducer } from "./Reducers/UnitDefaultChargeTemplates";
import { companyCreateReducer } from "./Reducers/CompanyCreate";
import { companyUpdateReducer } from "./Reducers/CompanyUpdate";
import { contractCreateReducer } from "./Reducers/ContractCreate";
import { contractUpdateReducer } from "./Reducers/ContractUpdate";
import { contractExtendReducer } from "./Reducers/ContractExtend";
import { chargeTemplateCreateReducer } from "./Reducers/ChargeTemplateCreate";
import { chargeTemplateUpdateReducer } from "./Reducers/ChargeTemplateUpdate";
import { agencyFeeCreateReducer } from "./Reducers/AgencyFeeCreate";
import { agencyFeeUpdateReducer } from "./Reducers/AgencyFeeUpdate";
import { userProfileReducer } from "./Reducers/UserProfile";
import { agencyProfileReducer } from "./Reducers/AgencyProfile";
import { emailAccountsReducer } from "./Reducers/EmailAccounts";
import { chargeCreateDialogReducer } from "./Reducers/ChargeCreateDialog";
import { chargeUpdateReducer } from "./Reducers/ChargeUpdate";
import { chargeUpdateDialogReducer } from "./Reducers/ChargeUpdateDialog";
import { paymentUpdateReducer } from "./Reducers/PaymentUpdate";
import { bankTransactionsReducer } from "./Reducers/BankTransactions";
import { paymentCreateDialogReducer } from "./Reducers/PaymentCreateDialog";
import { isReadonlyReducer } from "./Reducers/IsReadonly";
import { notificationUpdateReducer } from "./Reducers/NotificationUpdate";
import { activityTemplateCreateReducer } from "./Reducers/ActivityTemplateCreate";
import { activityTemplateUpdateReducer } from "./Reducers/ActivityTemplateUpdate";
import { activityCreateReducer } from "./Reducers/ActivityCreate";
import { activityUpdateReducer } from "./Reducers/ActivityUpdate";
import { taskTemplateCreateReducer } from "./Reducers/TaskTemplateCreate";
import { taskTemplateUpdateReducer } from "./Reducers/TaskTemplateUpdate";
import { eventCreateReducer } from "./Reducers/EventCreate";
import { eventUpdateReducer } from "./Reducers/EventUpdate";
import { bankAccountCreateReducer } from "./Reducers/BankAccountCreate";
import { bankAccountUpdateReducer } from "./Reducers/BankAccountUpdate";
import { financeUpdateReducer } from "./Reducers/FinanceUpdate";
import { mailsReducer } from "./Reducers/Mails";
import { propertiesPageReducer } from "./Reducers/PropertiesPage";
import { unitsPageReducer } from "./Reducers/UnitsPage";
import { chargesReducer } from "./Reducers/Entities/Charges";
import { paymentsReducer } from "./Reducers/Entities/Payments";
import { propertiesReducer } from "./Reducers/Entities/Properties";
import { unitsReducer } from "./Reducers/Entities/Units";
import { eventsReducer } from "./Reducers/Entities/Events";
import { companiesReducer } from "./Reducers/Entities/Companies";
import { personsReducer } from "./Reducers/Entities/Persons";
import { financialStatementsReducer } from "./Reducers/Entities/FinancialStatements";
import { globalTypesReducer } from "./Reducers/Entities/GlobalTypes";
import { bankTransactionFileUpdateReducer } from "./Reducers/BankTransactionFileUpdate";
import { chargeTypeCreateReducer } from "./Reducers/ChargeTypeCreate";
import { chargeTypeUpdateReducer } from "./Reducers/ChargeTypeUpdate";
import { emailSendReducer } from "./Reducers/EmailSend";
import { payChargesReducer } from "./Reducers/PayCharges";
import { conversationReducer } from "./Reducers/Conversation";
import { memoReducer } from "./Reducers/Memo";
import { taskCreateDialogReducer } from "./Reducers/TaskCreateDialog";
import { paymentCardViewReducer } from "./Reducers/PaymentCardView";
import { coachReducer } from "./Reducers/CoachReducer";

const RootReducer = combineReducers({
  routing: routerReducer,
  app: appReducer,
  token: tokenReducer,
  loading: loadingReducer,
  signup: signupReducer,
  checkEmail: checkEmailReducer,
  signout: signoutReducer,
  confirm: confirmReducer,
  container: containerReducer,
  forgotPassword: forgotPasswordReducer,
  contacts: contactsReducer,
  personCreate: personCreateReducer,
  personUpdate: personUpdateReducer,
  financeUpdate: financeUpdateReducer,
  companyCreate: companyCreateReducer,
  companyUpdate: companyUpdateReducer,
  propertyCreate: propertyCreateReducer,
  propertyUpdate: propertyUpdateReducer,
  unitUpdate: unitUpdateReducer,
  unitDefaultChargeTemplates: unitDefaultChargeTemplatesReducer,
  unitCreate: unitCreateReducer,
  contractCreate: contractCreateReducer,
  contractUpdate: contractUpdateReducer,
  contractExtend: contractExtendReducer,
  chargeTemplateCreate: chargeTemplateCreateReducer,
  chargeTemplateUpdate: chargeTemplateUpdateReducer,
  agencyFeeCreate: agencyFeeCreateReducer,
  agencyFeeUpdate: agencyFeeUpdateReducer,
  userProfile: userProfileReducer,
  agencyProfile: agencyProfileReducer,
  emailAccounts: emailAccountsReducer,
  chargeCreateDialog: chargeCreateDialogReducer,
  chargeUpdate: chargeUpdateReducer,
  chargeUpdateDialog: chargeUpdateDialogReducer,
  paymentUpdate: paymentUpdateReducer,
  bankTransactions: bankTransactionsReducer,
  paymentCreateDialog: paymentCreateDialogReducer,
  isReadonly: isReadonlyReducer,
  notificationUpdate: notificationUpdateReducer,
  activityTemplateCreate: activityTemplateCreateReducer,
  activityTemplateUpdate: activityTemplateUpdateReducer,
  activityCreate: activityCreateReducer,
  activityUpdate: activityUpdateReducer,
  taskTemplateCreate: taskTemplateCreateReducer,
  taskTemplateUpdate: taskTemplateUpdateReducer,
  eventCreate: eventCreateReducer,
  eventUpdate: eventUpdateReducer,
  bankAccountCreate: bankAccountCreateReducer,
  bankAccountUpdate: bankAccountUpdateReducer,
  mails: mailsReducer,
  propertiesPage: propertiesPageReducer,
  unitsPage: unitsPageReducer,
  charges: chargesReducer,
  payments: paymentsReducer,
  properties: propertiesReducer,
  units: unitsReducer,
  persons: personsReducer,
  companies: companiesReducer,
  events: eventsReducer,
  financialStatements: financialStatementsReducer,
  globalTypes: globalTypesReducer,
  bankTransactionFileUpdate: bankTransactionFileUpdateReducer,
  chargeTypeCreate: chargeTypeCreateReducer,
  chargeTypeUpdate: chargeTypeUpdateReducer,
  emailSend: emailSendReducer,
  payCharges: payChargesReducer,
  conversation: conversationReducer,
  memo: memoReducer,
  taskCreateDialog: taskCreateDialogReducer,
  paymentCardView: paymentCardViewReducer,
  coach: coachReducer,
});

export default RootReducer;
